import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from "../../gameData.js";
import DotTray from './DotTray.js';
import FaceTray from './FaceTray.js';
import PatchTray from './PatchTray.js';
import LetterTray from './LetterTray.js';
import PatternTray from './PatternTray.js';
import PaintTray from './PaintTray.js';

export default class Navbar extends AContainer
{
    constructor(scene)
    {
        super(scene);

        this.scene = scene;

        this.mainBtns = [];

        this.createBottom();
        this.createTop();
        this.tweenInNavbar();

        this.setPosition(-150, this.scene.mid.y);
        this.scene.addToParent(this, this.scene);
        this.setDepth(5);
    }

    createTop()
    {
        let btnIDs = ["Btn_Trim_Color", "Btn_Mask_Color", "Btn_Patterns", "Btn_Faces", "Btn_Patches", "Btn_Embroidery", "Btn_Paint"];

        this.topCont = this.scene.add.container();
        this.add(this.topCont);

        this.scene.addImage(-30, 0, "UI_Tray_Top", this.topCont);

        for(let i=0;i<btnIDs.length;i++){
            let btn = this.scene.addButton(40, -370 + (107*i), btnIDs[i], null, ()=>{
                if(btn.ind == gameData.gameMode) return; // don't close a drawer just to reopen it
                this.scene.removeTools();
                this.scene.playSound("click");
                this.toggleBtns(false);
                this.modeInd = btn.ind;
                gameData.gameMode == btnIDs.length ? this.tweenInBtn(this.modeInd) : this.tweenOutBtn(this.modeInd, true);
            }, this.topCont);

            btn.ind = i;
            btn.setEnabled(false);
            this.mainBtns.push(btn);
        }
    }

    createBottom()
    {
        this.botCont = this.scene.add.container();
        this.add(this.botCont);

        this.scene.addImage(-20, 0, "UI_Tray_Bottom", this.botCont);
        this.scene.addImage(125, 0, "UI_Tray_Shadow", this.botCont);

        this.trimTray = new DotTray(this.scene, this.botCont, "trim", 0);
        this.bgTray = new DotTray(this.scene, this.botCont, "bg", 1);
        this.patternTray = new PatternTray(this.scene, this.botCont, "patterns", 2);
        this.faceTray = new FaceTray(this.scene, this.botCont, "faces", 3);
        this.patchTray = new PatchTray(this.scene, this.botCont, "patch", 4);
        this.letterTray = new LetterTray(this.scene, this.botCont, "letter", 5);
        this.paintTray = new PaintTray(this.scene, this.botCont, "paint", 6);
        this.trays = [this.trimTray, this.bgTray, this.patternTray, this.faceTray, this.patchTray, this.letterTray, this.paintTray];

        this.disableTrays();
    }

    checkInitTab()
    {
        if(gameData.previousGameMode != 7 && gameData.gameMode == 7) this.tweenInBtn(gameData.previousGameMode);
        else if(gameData.gameMode != 7 && gameData.gameMode != gameData.gameModes.length) this.tweenInBtn(gameData.gameMode);
    }

    tweenInNavbar()
    {
        this.scene.playSound("drawer_open_close");

        this.scene.addTween(this, 500, {x:0}, Phaser.Math.Easing.Quadratic.Out,
            ()=>{
                this.toggleBtns(true);
                this.checkInitTab();
            }
        );
    }

    tweenOutNavbar()
    {
        this.scene.playSound("drawer_open_close");

        this.toggleBtns(false);

        this.disableTrays();

        if(gameData.gameMode == 5) this.letterTray.miniTray.tweenOutTray();
        if(gameData.gameMode == 6) this.paintTray.miniTray.tweenOutTray();
        
        this.scene.addTween(this, 500, {x:-175}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.botCont, 300, {x:0}, Phaser.Math.Easing.Quadratic.Out);
    }

    tweenInBtn(btn)
    {
        let btnInd = this.mainBtns.indexOf(this.mainBtns[btn]);
        gameData.gameMode = btn;

        this.disableTrays();
        this.trays[gameData.gameMode].visible = true;

        if(gameData.gameMode == 0) {
            if(gameData.trimColor) this.trays[gameData.gameMode].tweenInCursor(gameData.trimColor);
            else this.trays[gameData.gameMode].tweenInCursor("0x4c4b48");
        }
        else if(gameData.gameMode == 1) {
           if(gameData.bgColor) this.trays[gameData.gameMode].tweenInCursor(gameData.bgColor);
           else this.trays[gameData.gameMode].tweenInCursor("0xf2f0e7");
        }
        else if(gameData.gameMode == 2 || gameData.gameMode == 3 || gameData.gameMode == 4) {
            if(this.trays[gameData.gameMode].hasSlider){
                this.trays[gameData.gameMode].checkScrollState();
            }
        }
        else if(gameData.gameMode == 5) {
            if(gameData.letterColor) this.trays[gameData.gameMode].miniTray.tweenInCursor(gameData.letterColor);
            else this.trays[gameData.gameMode].miniTray.tweenInCursor("0xf2f0e7");
            this.letterTray.miniTray.tweenInTray();
        }
        else if(gameData.gameMode == 6) {
            if(gameData.paintColor) 
            {
                this.trays[gameData.gameMode].tweenInCursor(gameData.paintColor);
                this.paintTray.miniTray.setBtnTint(gameData.paintColor);
            }
            this.trays[gameData.gameMode].miniTray.tweenInCursor(gameData.brushSize);
            this.paintTray.miniTray.tweenInTray();
            this.scene.faceMask.setPaintColor();
        }

        for(let i=0;i<this.mainBtns.length;i++){
            if(btnInd === i){
                this.scene.addTween(this.mainBtns[i], 500, {x:60}, Phaser.Math.Easing.Bounce.Out,
                    ()=>{
                        this.trays[gameData.gameMode].toggleBtns(true);
                        this.toggleBtns(true);
                    }
                );
            }
            else{
                this.scene.addTween(this.mainBtns[i], 500, {x:40}, Phaser.Math.Easing.Bounce.Out);
            }
        }

        this.scene.playSound("drawer_open_close");
        this.scene.addTween(this.botCont, 300, {x:143}, Phaser.Math.Easing.Quadratic.Out);
        
    }

    tweenOutBtn(newLevel, reopen = false)
    {
        this.scene.addTween(this.mainBtns[gameData.gameMode], 500, {x:40}, Phaser.Math.Easing.Bounce.Out);

        this.letterTray.miniTray.tweenOutTray();
        this.paintTray.miniTray.tweenOutTray();

        this.scene.killTween(this.botCont);
        this.scene.addTween(this.botCont, 300, {x:0}, Phaser.Math.Easing.Quadratic.Out,
            ()=>{
                if(reopen) {
                    this.disableTrays();
                    this.tweenInBtn(newLevel);
                }
                else
                {
                    if(newLevel == null) gameData.gameMode = 7; // no drawer is open, so game mode is "none"
                }
            });
    }

    toggleBtns(onOff)
    {
        this.mainBtns.forEach(btn => {
            btn.setEnabled(onOff);
        });

        this.trays.forEach(tray => {
            tray.toggleBtns(false);
            if(onOff) if(tray.visible) tray.toggleBtns(true);
        });
    }

    clearActiveTrays()
    {
        this.trays.forEach(tray => {tray.isActive = false});
    }

    cleanTrays()
    {
        this.trays.forEach(tray => {
            tray.list.forEach(accessory => {
                if(!accessory.scene) {
                    //console.log("undefined bozo present");
                    accessory.destroy(true);
                    accessory = null;
                }
            });
        });
    }

    disableTrays()
    {
        this.trays.forEach(tray => {
            if(tray.cursor && !tray.isActive) tray.tweenOutCursor();
            if(gameData.gameMode !== tray.ind) tray.visible = false;
            tray.toggleBtns(false);
        });
    }

    cleanUp()
    {
        this.toggleBtns(false);
        this.disableTrays();

        this.trays.forEach(tray => {
            tray.cleanUp();
            //tray.destroy();
        });

        //this.topCont.destroy();
        //this.botCont.destroy();

        this.mainBtns = [];
    }
}